import React, { useEffect, useState } from 'react';
import { Details } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { routesName } from '../../constants/routes-name';
import { ApiManager } from '../../services/api';
import {
  Box,
  IconButton,
  Pagination,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { BreadcrumbsWrapper, TextFieldWrapper } from '../../components';
import { useQuery } from '../../constants/shared-methods';
import moment from 'moment';

function Component() {
  const { user, role } = useSelector(({ user }) => user);
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();
  const query = useQuery();
  const page = query.get('page') || 1;
  const [chatHeads, setChatHeads] = useState([]);
  const [pagination, setPagination] = useState();

  useEffect(() => {
    getChatsList(page);

    const interval = setInterval(() => {
      getChatsList(page);
    }, 30000);

    return () => clearInterval(interval);
  }, [page]);

  const getChatsList = async (page) => {
    const res = await ApiManager.getChatsList(page);
    if (res?.status === 200 && res?.data?.result) {
      setChatHeads(res.data.result);
      setPagination(res.data.pagination);
    }
  };

  const columns = [
    {
      field: 'title',
      headerName: 'Title',
      minWidth: 150,
      flex: 0.3,
      renderCell: (params) => {
        return (
          <div className="flex h-full items-center font-[600]">
            {params?.row?.title}
          </div>
        );
      },
    },
    {
      field: 'message',
      headerName: 'Message',
      minWidth: 220,
      flex: 1,
      renderCell: (params) => {
        const date = moment(params.row.createdAt);
        const isToday = date.isSame(moment(), 'day');
        const isSameYear = date.isSame(moment(), 'year');
        const displayValue = isToday
          ? date.format('HH:mm')
          : isSameYear
          ? date.format('MMM DD')
          : date.format('DD MMM YYYY');
        return (
          <div className="flex h-full  items-center justify-end text-[var(--gray)]">
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Typography>{params.row.message}</Typography>
              <Typography
                sx={{
                  position: 'absolute',
                  right: 0,
                  backgroundColor: 'inherit',
                  padding: '2px 4px',
                  borderRadius: '4px',
                  visibility: 'hidden',
                  opacity: 0,
                  transition: 'visibility 0s, opacity 0.2s ease-in-out',
                  fontSize: '12px',
                  fontWeight: 600,
                }}
                className="hover-created-date"
              >
                {displayValue}
              </Typography>
            </Box>
          </div>
        );
      },
    },

    /*    {
      field: 'action',
      headerName: 'Actions',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      minWidth: 90,
      flex: 0.2,
      headerAlign: 'right',
      renderCell: (params) => {
        const date = moment(params.row.createdAt);
        const isToday = date.isSame(moment(), 'day');
        const displayValue = isToday
          ? date.format('HH:mm')
          : date.format('DD MMM YYYY');
        return (
          <div className="flex h-full  items-center justify-end text-[var(--gray)]">
            <Tooltip title="Click to see details" arrow>
              <IconButton size="small">
                <Details fontSize="small" />
              </IconButton>
            </Tooltip>

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Typography>{params.row.name}</Typography>
              <Typography
                sx={{
                  position: 'absolute',
                  right: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  padding: '2px 4px',
                  borderRadius: '4px',
                  visibility: 'hidden',
                  opacity: 0,
                  transition: 'visibility 0s, opacity 0.2s ease-in-out',
                }}
                className="hover-created-date"
              >
                {displayValue}
              </Typography>
            </Box>
          </div>
        );
      },
    }, */
  ];

  const rows =
    chatHeads && Array.isArray(chatHeads)
      ? chatHeads.map((item, index) => ({
          id: item?._id || index,
          title: item?.title || item?.replyTo?.title || '',
          message: item?.message || '',
          tender: item?.tender || '',
          chatGroup: item?.chatGroup || '',
          createdAt: item?.createdAt || '',
        }))
      : [];

  const breadcrumbs = [
    { title: 'Dashboard', path: routesName.dashboard },
    { title: 'Chats' },
  ];

  return (
    <div className="flex flex-col gap-8">
      <BreadcrumbsWrapper breadcrumbs={breadcrumbs} />
      <div className="flex flex-col gap-8">
        <div>
          <div className="flex justify-between items-center">
            <div className="text-xl font-bold">Chats</div>
          </div>

          <div className="flex flex-col gap-3 py-6">
            {rows && (
              <div>
                <DataGrid
                  onRowClick={(params) =>
                    navigate(
                      `${routesName.openChat}?mid=${params.row.chatGroup}`
                    )
                  }
                  sx={{
                    /* overflowX: 'auto', */
                    '& .MuiDataGrid-columnHeaders div': {
                      backgroundColor: 'var(--blue) !important',
                      textAlign: 'center !important',
                      color: 'white !important',
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                      backgroundColor: 'white !important',
                    },
                    '& .MuiDataGrid-row:hover .hover-created-date': {
                      visibility: 'visible',
                      opacity: 1,
                    },
                    '& .MuiDataGrid-row:hover': {
                      cursor: 'pointer',
                    },
                  }}
                  rows={rows}
                  columns={columns}
                  disableColumnMenu
                  //disableColumnSorting
                  //disableColumnResize
                  hideFooter
                  autoHeight
                />
                <Pagination
                  variant="outlined"
                  color="primary"
                  page={pagination?.currentPage || 1}
                  component="div"
                  onChange={(event, newPage) => {
                    navigate(`${routesName.chats}?page=${newPage}`);
                  }}
                  count={pagination?.totalPage || 1}
                  className="flex-shrink-0 border-t-1 flex justify-center mt-2"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Component;
